// extracted by mini-css-extract-plugin
export var productImage = "_m5-1";
export var viewLink = "_m5-2";
export var wishlistItem = "_m5-0";